export const name: string = 'Reset Password';
export const group = 'Administrative';
export const moduleName: string = 'pdc-widget-reset-password';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-reset-password';
//export const priority: number = 1;
